module.exports = __webpack_public_path__ + "static/media/adjustable_stay_rod_assembly.80e06479.webp";